<template>
  <div id="app">
    <main-navbar></main-navbar>
    <main-content></main-content>
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainNavbar from '@/components/layout/MainNavbar';
import MainContent from '@/components/layout/MainContent';
import MainFooter from '@/components/layout/MainFooter';

export default {
  name: 'app',
  components: {
    MainNavbar,
    MainContent,
    MainFooter,
  },
};
</script>

<style lang="scss">
@import 'main';
</style>



// WEBPACK FOOTER //
// App.vue?515347dd